import BarChart from "components/charts/BarChart";
import LineChart from "components/charts/LineChart";
import PieChart from "components/charts/PieChart";
import Modals from "components/Modal";
import TableTwo from "components/TableTwo";
import { format } from "date-fns";
import { subMonths } from "date-fns/esm";
import useUserReport from "hook/reports/useUserReport";
import { DONATION_REPORT, USER_REPORT } from "navigation/routes";
import { useState } from "react";
import { Link } from "react-router-dom";
import { jsPDF } from "jspdf";

const UserAnalytics = () => {
  const { dummy_data, dummy_line_data, dummy_line2_data, dummy_pie_data } = useUserReport();

  const downloadPDF = (e, filename) => {
    e.preventDefault();
    const card = e.target.closest('.card');
    const canvas = card.querySelector('canvas');
    if (canvas) {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('landscape');
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${filename}.pdf`);
    }
  };

  const downloadChart = (e, filename) => {
    e.preventDefault();
    const card = e.target.closest('.card');
    const canvas = card.querySelector('canvas');
    if (canvas) {
      const url = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = `${filename}.png`;
      link.href = url;
      link.click();
    }
  };
  return (
    <>

      <div className="container-fluid px-4">
        <div className="d-sm-flex align-items-start justify-content-between mt-4">
          <div>
            <h1>User Analytics</h1>
            <ol className="breadcrumb mb-2">
              <li className="breadcrumb-item"><Link to={`../${USER_REPORT}`}>User</Link></li>
              <li className="breadcrumb-item active">Analytics</li>
            </ol>
          </div>
          <Link className="btn btn-primary mb-2" to={`../${USER_REPORT}`} relative="path">View List</Link>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="card mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div>
                    <i className="fas fa-chart-bar me-1"></i>
                    New Users by month
                  </div>
                  <div>
                    <button className="btn btn-sm btn-outline-primary me-2" onClick={(e) => downloadChart(e, 'New_Users_by_month')}>
                      <i className="fas fa-image"></i> Image
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={(e) => downloadPDF(e, 'New_Users_by_month')}>
                      <i className="fas fa-file-pdf"></i> PDF
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <BarChart data={dummy_data} />
                </div>
                <div className="card-footer small text-muted">Updated yesterday at 11:59 PM
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div>
                    <i className="fas fa-chart-bar me-1"></i>
                    Donations for {format(new Date(), 'MMM yyyy')}
                  </div>
                  <div>
                    <button className="btn btn-sm btn-outline-primary me-2" onClick={(e) => downloadChart(e, 'Donations_' + format(new Date(), 'MMM_yyyy'))}>
                      <i className="fas fa-image"></i> Image
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={(e) => downloadPDF(e, 'Donations_' + format(new Date(), 'MMM_yyyy'))}>
                      <i className="fas fa-file-pdf"></i> PDF
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <LineChart data={dummy_line_data} />
                </div>
                <div className="card-footer small text-muted">Updated yesterday at 11:59 PM
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div>
                    <i className="fas fa-chart-bar me-1"></i>
                    Donations for {format(subMonths(new Date(), 1), 'MMM yyyy')}
                  </div>
                  <div>
                    <button className="btn btn-sm btn-outline-primary me-2" onClick={(e) => downloadChart(e, 'Donations_' + format(subMonths(new Date(), 1), 'MMM_yyyy'))}>
                      <i className="fas fa-image"></i> Image
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={(e) => downloadPDF(e, 'Donations_' + format(subMonths(new Date(), 1), 'MMM_yyyy'))}>
                      <i className="fas fa-file-pdf"></i> PDF
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <LineChart data={dummy_line2_data} />
                </div>
                <div className="card-footer small text-muted">Updated yesterday at 11:59 PM
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div>
                    <i className="fas fa-chart-bar me-1"></i>
                    Total Donations in Naira categorized by cycle for {format(new Date(), 'yyyy')}
                  </div>
                  <div>
                    <button className="btn btn-sm btn-outline-primary me-2" onClick={(e) => downloadChart(e, 'Total_Donations_By_Cycle_' + format(new Date(), 'yyyy'))}>
                      <i className="fas fa-image"></i> Image
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={(e) => downloadPDF(e, 'Total_Donations_By_Cycle_' + format(new Date(), 'yyyy'))}>
                      <i className="fas fa-file-pdf"></i> PDF
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <PieChart data={dummy_pie_data} />
                </div>
                <div className="card-footer small text-muted">Updated yesterday at 11:59 PM
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserAnalytics;
